import React, { useState, useEffect } from "react";
import "./App.css";
import Home from "./home/home";
import StatusDetails from "./status/status-details";
import { UncontrolledAlert } from "reactstrap";
//import { sampleState } from "./common/defaultState"; //mock-data
import { /*I18nProvider,*/ LOCALES } from './i18n';
//import { FormattedMessage } from 'react-intl';
//import t from './i18n/translate';

export default function App() {
    const [alerts, setAlert] = useState([]);

    const [state, setState] = useState({}); // useState(sampleState);
    //const [lang, setLang] = useState("en");
    const [lang, setLang] = useState(LOCALES.EHGLISH);
    const [en, setEN] = useState({});
    const [fr, setFR] = useState({});

    const [useTitle, setuseTitle] = useState(false);
    const [recaptchaSiteKey, setRecaptchaSiteKey] = useState("");
    const [usecaptcha, setUsecaptcha] = useState(false);
    const [useTranslation, setUseTranslation] = useState(false);
    const [useFontOptions, setUseFontOptions] = useState(false);
    const [initiatedByApp, setInitiatedByApp] = useState(false);

    const [problemTypes, setProblemTypes] = useState([]);
    const [problemTypesCommon, setProblemTypesCommon] = useState([]);

    const [isHome, setIsHome] = useState(true);
    const [isStart, setIsStart] = useState(false);
    const [token, setToken] = useState("");
    const [extent, setExtent] = useState({});
    const [sp, setSp] = useState(-1);


    //==========
    const [geomUrl, setGeomUrl] = useState("");
    const [geomToken, setGeomToken] = useState("");
    const [gcoderUrl, setGeoCoderUrl] = useState("");
    const [gcoderToken, setGeoCoderToken] = useState("");
    const [addressField, setAddressField] = useState("");

    const [geomTokenRequired, setGeomTokenRequired] = useState(false);
    const [gcoderTokenRequired, setGcoderTokenRequired] = useState(false);
    const [fontSize, setFontSize] = useState(16);
    const [mapZoom, setMapZoom] = useState(20);



    useEffect(() => {
        loadDiv("show");
        getConfig();
       // getProblems();
    }, []);

    const Guid = () => {
        return (
            "uuid-" +
            (new Date().getTime().toString(16) +
                Math.floor(1e7 * Math.random()).toString(16))
        );
    };

    const setAlerts = (msg, type) => {
        if (msg) setAlert([{ guid: Guid(), info: msg, color: type }]);
    };

    const clearAlerts = () => {
        setAlert([]);
    };

    const loadDiv = (option, txt) => {
        //block/none
        document.getElementById("overlay").style.display =
            option === "show" ? "block" : "none";
        document.getElementById("loadmsg").innerHTML = txt ? txt : "Loading...";
    };

    const changeLang = (ev) => {
        setLang(ev === "en" ? LOCALES.FRENCH : LOCALES.EHGLISH);
       // setLang(LOCALES.FRENCH);

    };

    const changePage = (ev) => {
        loadDiv("hide");
        setIsHome(ev ? false : true);
        clearAlerts();
    };

    const showHome = () => {
        setIsHome(null);
        state.problemtype.valueDesc = "";
        state.problemLocation.valueDesc = "";
       // console.log("home state=>",state);
        //state.problemtype.valueDesc = "";
        setIsHome(true);
    }

    const translate = (_lang, name) => {
        let result = "";
        try {
            if (_lang === "en") {
                result = en[name] ? en[name] : name;
            } else {
                result = fr[name] ? fr[name] : name;
            }
        } catch {
            result = name;
        }
        return result;
    };

    const getProblems = (t) => {
        window
            .fetch(`GetProblems?token=${t}`)
            .then((resp) => {
                return resp.json();
            })
            .then((data) => {
                loadDiv("hide");
                if (data.status === 0) {
                    setProblemTypesCommon(data.valueCommon);
                    setProblemTypes(data.value);

                } else {
                    setAlerts(data.message, "danger");
                }
            });
    };

    const getConfig = () => {
        window
            .fetch("GetConfig")
            .then((resp) => {
                return resp.json();
            })
            .then((data) => {
                if (data.status === 0) {
                    let trans = JSON.parse(data.translation);
                    setEN(trans["en"]);
                    setFR(trans["fr"]);
                    setuseTitle(data.useTitle);
                    setInitiatedByApp(data.initiatedByApp);
                    setUseTranslation(data.useTranslation);
                    setUseFontOptions(data.useFontOptions);
                    setUsecaptcha(data.usecaptcha);
                    setRecaptchaSiteKey(data.recaptchaSiteKey);
                    setToken(data.token);
                    setExtent(data.extent);
                    setSp(data.sp);
                    setGeomUrl(data.geomurl);
                    setGeomToken(data.geomt);
                    setGeoCoderUrl(data.gcodeurl);
                    setGeoCoderToken(data.gcodet);
                    setAddressField(data.geoCoderAddressField);
                    setMapZoom(data.mapZoom);

                    setGeomTokenRequired(data.geoms);
                    setGcoderTokenRequired(data.gcodes);
       


                    getProblems(data.token);

                    let values = data.value;

                    let nValues = {};
                    Object.values(values).forEach((v) => {
                        let o = { ...v, value: "", status: -1 };
                        if (o.name === "problemLocation") o = { ...v, value: "", valueDesc:"",status: -1 };//problemLocation.valueDesc 
                        nValues[o.name] = o;
                        
                       // console.log(o);
                    });
                    nValues["maprefresh"] = { name: "maprefresh", value: "-1", extent: {} };
                    //maprefresh
                    nValues["x"] = { name: "x", value: null };
                    nValues["y"] = { name: "y", value: null };
                    

                    setState(nValues);
                   // console.log(nValues);

                    //loadDiv("hide");
                    setIsStart(true);

                    //  console.log("isStart",isStart);
                    //  console.log("isHome", isHome);
                    //  console.log("problemTypes",problemTypes);
                    //  console.log("problemTypes.length>0",problemTypes.length>0);
              

                } else {
                    setAlerts(data.message, "danger"); loadDiv("hide");
                }
            });
    };

    const changeFont = (size) => {
      
        setFontSize(size);
        document.getElementById("appFont").style.fontSize = `${size}px`;
    }

    return (
        <>
            <div id="appFont">
            {/* <I18nProvider locale={lang}>*/}
            {/* {t('language')} 
            {t('edit', {path:<span>test</span>})} */}
            <div id="overlay">
                <span className="loadMessage" id="loadmsg"></span>
            </div>

            <div className="my-alert">
                {alerts.map((e) => (
                    <UncontrolledAlert color={e.color} key={e.guid}>{e.info}</UncontrolledAlert>
                ))}
            </div>

            <>
                {(isStart && isHome && problemTypes && problemTypes.length > 0) ? (
                    <Home 
                            loadDiv={loadDiv}
                            lang={lang}
                            state={state}
                            en={en}
                            fr={fr}
                            useTitle={useTitle}
                            usecaptcha={usecaptcha}
                            useTranslation={useTranslation}
                            useFontOptions={useFontOptions}
                            initiatedByApp={initiatedByApp}
                            changeLang={changeLang}
                            isHome={isHome}
                            changePage={changePage}
                            showHome={showHome}
                            translate={translate}
                            getConfig={getConfig}
                            problemTypes={problemTypes}
                            recaptchaSiteKey={recaptchaSiteKey}
                            setAlerts={setAlerts}
                            clearAlerts={clearAlerts}
                            Guid={Guid}
                            problemTypesCommon={problemTypesCommon}
                            token={token}
                            extent={extent}
                            sp={sp}
                            geomUrl={geomUrl}
                            geomToken={geomToken}
                            gcoderUrl={gcoderUrl}
                            gcoderToken={gcoderToken}
                            addressField={addressField}
                            geomTokenRequired={geomTokenRequired}
                            gcoderTokenRequired={gcoderTokenRequired}
                            fontSize={fontSize}
                            changeFont={changeFont}
                            mapZoom={mapZoom}
                    />

                ) : (
                        ""
                    )}
                {!isHome ? (
                    <StatusDetails
                        loadDiv={loadDiv}
                        lang={lang}
                        state={state}
                        en={en}
                        fr={fr}
                        useTitle={useTitle}
                        usecaptcha={usecaptcha}
                        useTranslation={useTranslation}
                        initiatedByApp={initiatedByApp}
                        isHome={isHome}
                        changePage={changePage}
                        translate={translate}
                        setAlerts={setAlerts}
                        clearAlerts={clearAlerts}
                        Guid={Guid}
                        token={token}
                      
                    />
                ) : (
                        ""
                    )}
            </>
                {/* </I18nProvider>*/}
                </div>
            </>
    );
}
